export type PortfolioShot = {
  src: string
  alt: string
  caption: string
}

export type PortfolioProject = {
  id: string
  anchor: string
  title: string
  eyebrow: string
  description: string
  capabilities: string[]
  tech: string[]
  href?: string
  hrefLabel?: string
  primary: PortfolioShot
  gallery: PortfolioShot[]
}

export const PORTFOLIO_PROJECTS: PortfolioProject[] = [
  {
    id: "black-velvet-records",
    anchor: "black-velvet-records",
    title: "BLACK VELVET RECORDS",
    eyebrow: "DESTINATION 01",
    description:
      "An independent music platform connecting artists, listeners and music discovery through reviews, submissions and interactive experiences.",
    capabilities: [
      "Live host hubs and fan queues",
      "Song Wars competitions",
      "Artist discovery and catalog",
      "Music submission workflows",
    ],
    tech: ["React", "Vite", "MUI", "Prisma", "Stripe"],
    href: "https://blackvelvetrecords.com",
    hrefLabel: "OPEN BLACK VELVET",
    primary: {
      src: "/images/portfolio/black-velvet-records/bvr-home.webp",
      alt: "Black Velvet Records homepage with dark cinematic hero",
      caption: "Home / discovery",
    },
    gallery: [
      {
        src: "/images/portfolio/black-velvet-records/song-war.webp",
        alt: "Song Wars competition page with completed bracket card",
        caption: "Song Wars",
      },
      {
        src: "/images/portfolio/black-velvet-records/artist-dashboard.webp",
        alt: "Black Velvet Records artists directory",
        caption: "Artists",
      },
      {
        src: "/images/portfolio/black-velvet-records/bvr-live.webp",
        alt: "Black Velvet Records live discovery",
        caption: "Live",
      },
    ],
  },
  {
    id: "gamedna",
    anchor: "gamedna",
    title: "GAMEDNA",
    eyebrow: "DESTINATION 02",
    description:
      "A sports intelligence platform bringing together game data, statistics, analysis and AI-powered prediction experiences.",
    capabilities: [
      "Game Center and live scores",
      "Gameday prediction surfaces",
      "Player and team analysis",
      "Injury and standings context",
    ],
    tech: ["Next.js", "React", "TypeScript", "sports data APIs"],
    hrefLabel: "LOCAL PRODUCT (gamedna.ai parked)",
    primary: {
      src: "/images/portfolio/gamedna/gamedna-home.webp",
      alt: "GameDNA NBA home with scores, model leans and standings",
      caption: "Home / Game Center",
    },
    gallery: [
      {
        src: "/images/portfolio/gamedna/game-center.webp",
        alt: "GameDNA games list interface",
        caption: "Games",
      },
      {
        src: "/images/portfolio/gamedna/game-prediction.webp",
        alt: "GameDNA gameday prediction experience",
        caption: "Gameday / predictions",
      },
      {
        src: "/images/portfolio/gamedna/player-analysis.webp",
        alt: "GameDNA player analysis profile",
        caption: "Player analysis",
      },
      {
        src: "/images/portfolio/gamedna/gamedna-admin.webp",
        alt: "GameDNA Admin local operator desk",
        caption: "Admin (local)",
      },
    ],
  },
  {
    id: "bvr",
    anchor: "bvr",
    title: "BVR — CREATIVE TECHNOLOGY",
    eyebrow: "DESTINATION 03",
    description:
      "A collection of music production tools combining AI, digital instruments and creative workflows. FLOW for Ableton-connected production. VOLT for subtractive synthesis.",
    capabilities: [
      "FLOW studio and song workflows",
      "Ableton Live bridge integration",
      "AI-assisted song maker",
      "VOLT synthesizer and visualizer",
    ],
    tech: ["TypeScript", "Ableton bridge", "JUCE", "Web UI"],
    primary: {
      src: "/images/portfolio/bvr/bvr-flow.webp",
      alt: "BVR FLOW home production interface",
      caption: "FLOW home",
    },
    gallery: [
      {
        src: "/images/portfolio/bvr/bvr-flow-ableton.webp",
        alt: "BVR FLOW play screen with Ableton integration",
        caption: "FLOW play / Ableton",
      },
      {
        src: "/images/portfolio/bvr/bvr-flow-ai.webp",
        alt: "BVR FLOW song maker AI workflow",
        caption: "FLOW song maker",
      },
      {
        src: "/images/portfolio/bvr/bvr-volt.webp",
        alt: "BVR VOLT synthesizer main interface",
        caption: "VOLT main",
      },
      {
        src: "/images/portfolio/bvr/bvr-volt-visualizer.webp",
        alt: "BVR VOLT instrument controls and visualizer",
        caption: "VOLT visualizer",
      },
      {
        src: "/images/portfolio/bvr/bvr-volt-keys.webp",
        alt: "BVR VOLT keyboard and sound design",
        caption: "VOLT keys",
      },
    ],
  },
]
